export * from './SlantTitle';